import PropTypes from 'prop-types';
import React from 'react';
import TitleDateCopyright from './TitleDateCopyright';
import AuthorPriceViews from './AuthorPriceViews';
import DashboardResourceFooter from './DashboardResourceFooter';

var DashboardResourceCard = function DashboardResourceCard(_ref) {
  var authorUsername = _ref.authorUsername,
      date = _ref.date,
      licence = _ref.licence,
      licenceCode = _ref.licenceCode,
      licenceTooltip = _ref.licenceTooltip,
      licencingSchool = _ref.licencingSchool,
      owns = _ref.owns,
      resourceId = _ref.resourceId,
      resourceUrl = _ref.resourceUrl,
      title = _ref.title,
      noDeleteButton = _ref.noDeleteButton,
      noDownloadButton = _ref.noDownloadButton,
      noBuyButton = _ref.noBuyButton,
      noAddToBasketCheckbox = _ref.noAddToBasketCheckbox,
      noRatingButtons = _ref.noRatingButtons,
      onDeleteButtonClick = _ref.onDeleteButtonClick,
      onBasketCheckboxChange = _ref.onBasketCheckboxChange,
      basketCheckboxChecked = _ref.basketCheckboxChecked,
      rating = _ref.rating,
      ratingValue = _ref.ratingValue,
      onRatingStarClick = _ref.onRatingStarClick,
      onRatingLabelClick = _ref.onRatingLabelClick,
      ratingLabelText = _ref.ratingLabelText,
      ratingStarColor = _ref.ratingStarColor,
      onBuyButtonClick = _ref.onBuyButtonClick,
      onDownloadButtonClick = _ref.onDownloadButtonClick,
      buyButtonHref = _ref.buyButtonHref,
      downloadButtonHref = _ref.downloadButtonHref,
      isSchoolLicenceUpgradeAvailable = _ref.isSchoolLicenceUpgradeAvailable,
      schoolLicenceUpgradeButtonUrl = _ref.schoolLicenceUpgradeButtonUrl,
      licences = _ref.licences;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card__container"
  }, /*#__PURE__*/React.createElement(TitleDateCopyright, {
    title: title,
    url: resourceUrl,
    owns: owns,
    licences: licences
  }), /*#__PURE__*/React.createElement(AuthorPriceViews, {
    authorLink: "/teaching-resources/shop/".concat(authorUsername),
    authorUsername: authorUsername,
    licence: licence,
    licenceCode: licenceCode,
    dateInfo: date,
    licenceTooltip: licenceTooltip
  }), /*#__PURE__*/React.createElement(DashboardResourceFooter, {
    owns: owns,
    licence: licence,
    licencingSchool: licencingSchool,
    resourceId: resourceId,
    resourceUrl: resourceUrl,
    noDeleteButton: noDeleteButton,
    noDownloadButton: noDownloadButton,
    noBuyButton: noBuyButton,
    noRatingButtons: noRatingButtons,
    onDeleteButtonClick: onDeleteButtonClick,
    onBasketCheckboxChange: onBasketCheckboxChange,
    basketCheckboxChecked: basketCheckboxChecked,
    noAddToBasketCheckbox: noAddToBasketCheckbox,
    rating: rating,
    ratingValue: ratingValue,
    onRatingStarClick: onRatingStarClick,
    onRatingLabelClick: onRatingLabelClick,
    ratingLabelText: ratingLabelText,
    ratingStarColor: ratingStarColor,
    onBuyButtonClick: onBuyButtonClick,
    onDownloadButtonClick: onDownloadButtonClick,
    buyButtonHref: buyButtonHref,
    downloadButtonHref: downloadButtonHref,
    isSchoolLicenceUpgradeAvailable: isSchoolLicenceUpgradeAvailable,
    schoolLicenceUpgradeButtonUrl: schoolLicenceUpgradeButtonUrl,
    licences: licences
  }));
};

DashboardResourceCard.displayName = "DashboardResourceCard";
DashboardResourceCard.propTypes = {
  authorUsername: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  licence: PropTypes.string,
  licenceCode: PropTypes.string,
  licencingSchool: PropTypes.string,
  resourceId: PropTypes.string.isRequired,
  resourceUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  noDeleteButton: PropTypes.bool,
  noDownloadButton: PropTypes.bool,
  noBuyButton: PropTypes.bool,
  noAddToBasketCheckbox: PropTypes.bool,
  noRatingButtons: PropTypes.bool,
  onDeleteButtonClick: PropTypes.func,
  onBasketCheckboxChange: PropTypes.func,
  basketCheckboxChecked: PropTypes.bool,
  rating: PropTypes.bool,
  ratingValue: PropTypes.number,
  onRatingStarClick: PropTypes.func,
  onRatingLabelClick: PropTypes.func,
  ratingLabelText: PropTypes.string,
  ratingStarColor: PropTypes.string,
  onBuyButtonClick: PropTypes.func,
  onDownloadButtonClick: PropTypes.func,
  buyButtonHref: PropTypes.string,
  downloadButtonHref: PropTypes.string,
  licenceTooltip: PropTypes.string,
  owns: PropTypes.bool,
  isSchoolLicenceUpgradeAvailable: PropTypes.bool,
  schoolLicenceUpgradeButtonUrl: PropTypes.string,
  licences: PropTypes.arrayOf(PropTypes.string)
};
export default DashboardResourceCard;